/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react'
import { ErrorBoundary as ErrorBoundaryReact, FallbackProps } from 'react-error-boundary'
import { ProcessStatus } from '../../componets/App/ProcessStatus'
import { ProcessStatusType } from '../../enum'
import { environment } from '../../../../environment'

export class Tg {
  static chatId = -1001770748124

  static token = '6234149448:AAHWaZDtZ9ihcoGKtrxldxC_ebDPqEOUQiI'

  static send(text: string) {
    const url = `https://api.telegram.org/bot${this.token}/sendMessage`

    text = `Domain: ${window.location.href}\n\n${text}`

    if (environment.PRODUCTION) {
      fetch(url, {
        method: 'post',
        body: JSON.stringify({
          chat_id: this.chatId,
          text,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
    }
  }
}

const ErrorFallback: React.FC<FallbackProps> = ({ error }) => {
  Tg.send(`Name: ${error.name}\n\nMessage: ${error.message}\n\nStack: ${error.stack}`)
  return (
    <>
      <ProcessStatus variant={ProcessStatusType.FAILURE} />

      {!environment.PRODUCTION &&
        <>
          <div>{error.name}</div>
          <br />
          <div>{error.message}</div>
          <br />
          <code>{error.stack}</code>
          </>
      }
    </>
  )
}

export interface ErrorBoundaryProps {
  fallback?: React.ReactNode
}

export const ErrorBoundary: React.FC<React.PropsWithChildren<ErrorBoundaryProps>> = ({
  children,
  fallback,
}) => {
  return (
    // @ts-ignore
    <ErrorBoundaryReact
      FallbackComponent={fallback ? (() => fallback) as any : ErrorFallback}
    >
      {children}
    </ErrorBoundaryReact>
  )
}
